// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13n25","footer":"styles_footer__3hLaJ","passCodeTooltip":"styles_passCodeTooltip__3nz5-"};